<template>
  <div class="col-12 col-lg-9 inner-page grid-width-common" id="top">
    <section class="speaker-detail-wrapper">
      <div class="speaker-detail">
        <div class="container-row">
          <div class="row">
            <div class="col-md-3">
              <div class="image-wrapper">
                <img v-if="avatar == null || avatar == 'https://www.dmgeventsconferences.com/'"
                  src="https://hydrogenexpo.com/media/xiadtpms/deafult-speaker-hydrogen.jpg"
                  alt="Mark McDougall  300x300">
                <img class="img-fluid" v-else :srcset="avatar">
              </div>
            </div>
            <div class="col-md-9">
              <div class="content">
                <h3>{{ name }}</h3>
                <h5>{{ jobTitle }}</h5>
                <h6>{{ company }}</h6>
                <h6>{{ country }}</h6>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 speaker-bio">
              <p>{{ biography }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--<section class="speaker-related-sessions speaker-detail-wrapper">
        <div class="related-wrapper">
          <div class="main-heading">
            <h4>related sessions</h4>
          </div>
          <ul class="content-body">
            <li><a href="/conference/2023-technical-courses-program/#tuesday-block-29876" target="_self">Codes &amp;
                Standards and Hydrogen Safety in Design</a></li>
          </ul>
        </div>
      </section>-->
  </div>

</template>
<script>
//import $ from 'jquery';
import axios from "axios";
import url from "./../../config/url";
export default {
  name: "ExhibitorProfilePage",
  data: function () {
    return {
      exhibitorid: this.$route.query.userId,
      id: null,
      name: null,
      jobTitle: null,
      company: null,
      biography: null,
      avatar: null,
      country: null
    };
  },
  mounted() {
    this.exhibitorDetails(this.exhibitorid);
  },
  methods: {
    exhibitorDetails: function (eId) {
      // debugger
      axios
        .get(url.user_detail_api, { params: { Userid: eId } })
        .then(response => {
          //    debugger
          this.id = response.data[0].id;
          this.name = response.data[0].name;
          this.jobTitle = response.data[0].jobTitle;
          this.company = response.data[0].company;
          this.biography = response.data[0].biography;
          this.avatar = response.data[0].avatar;
          this.country = response.data[0].country;
        })
        .catch(error => {
          console.log(error);
        });
      window.scrollTo(0, 0);
    },

    exhibitorProductData: function () {
      (this.showProductCategory = true),
        (this.showPressRelease = false),
        (this.showBrochure = false);
    },
    exhibitorPressReleaseData: function () {
      (this.showProductCategory = false),
        (this.showPressRelease = true),
        (this.showBrochure = false);
    },
    exhibitorBrochuresData: function () {
      (this.showProductCategory = false),
        (this.showPressRelease = false),
        (this.showBrochure = true);
    }
  }
};





</script>
